export const TEST_ID_SORTING_DESKTOP_SORT_TYPE_BTN =
  'TEST_ID_SORTING_DESKTOP_SORT_TYPE_BTN';
